import {
    HttpClient,
    HttpParams,
    HttpHeaders,
} from '@angular/common/http';
import { Injectable, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { Responses } from 'src/app/models/interfaces/responses';
import { environment } from 'src/environments/environment';



@Injectable({
    providedIn: 'root',
})
export class ApiImageService {
    public domain: string = environment.baseApiUrl;
    constructor(protected http: HttpClient) { }

    getImages(directory_id: number): Observable<Responses> {
        return this.http.get<Responses>(
            this.domain + 'extensions/images/all/' + directory_id
        );
    }
    updateImage(form: UntypedFormGroup): Observable<Responses> {
        const body = new HttpParams().appendAll(form.value);
        return this.http.post<Responses>(
          this.domain + 'extensions/images/update/',
          body,
          {
            headers: new HttpHeaders().set(
              'Content-Type',
              'application/x-www-form-urlencoded'
            ),
          }
        );
      }
    deleteImage(id: number): Observable<Responses> {
        const body = new HttpParams().set('id', id);
        return this.http.post<Responses>(
          this.domain + 'extensions/images/delete/',
          body,
          {
            headers: new HttpHeaders().set(
              'Content-Type',
              'application/x-www-form-urlencoded'
            ),
          }
        );
      }
    
      getImage(id: number) {
        return this.domain + 'download/image/' + '&id=' + id;
      }
}